import * as React from 'react';
import { useSliderContext } from '@cian/slider';
import { useDispatch } from 'react-redux';

import { OnboardingSwitcher } from '../../../../components/OnboardingSwitcher';
import { TOnboardingSlide } from '../index';
import { openOnboardingModal } from '../../../../slices';
import { trackClickOnboardingBackButton, trackClickOnboardingButton, setOnboardingCloseCookies } from '../../utils';

type TProps = {
  slides: TOnboardingSlide[];
  isMobile?: boolean;
};

export const OnboardingSwitcherContainer: React.FC<TProps> = ({ slides, isMobile }) => {
  const { currentSlide, scrollNext, scrollPrev } = useSliderContext();

  const dispatch = useDispatch();

  const handleNextClick = React.useCallback(() => {
    scrollNext();
    trackClickOnboardingButton(1);
  }, [scrollNext, currentSlide]);

  const handlePrevClick = React.useCallback(() => {
    scrollPrev();
    trackClickOnboardingBackButton();
  }, [scrollPrev]);

  const handleFinishClick = React.useCallback(() => {
    dispatch(openOnboardingModal(false));
    trackClickOnboardingButton(2);

    setOnboardingCloseCookies();
  }, [dispatch]);

  return (
    <OnboardingSwitcher
      hasNextButton={slides[currentSlide].hasNextButton}
      hasPrevButton={slides[currentSlide].hasPrevButton}
      hasFinishButton={slides[currentSlide].hasFinishButton}
      onNextClick={handleNextClick}
      onPrevClick={handlePrevClick}
      onFinishClick={handleFinishClick}
      isMobile={isMobile}
    />
  );
};
